export const externalLinks = {
  termsAndConditionsLink:
    'https://www.sensibleweather.com/guarantee-terms-and-conditions',
  termsAndConditionsLinkText: 'generic.label.terms_conditions',
};
